/* istanbul ignore file */
export { default } from './RrpOrderSummary';
